(()=>{
  const STORE_KEY='2in1flags:printify-mockups:v10';
  const DRAFT_KEY='2in1flags:design:draft:v1';
  let colorToast=false;
  const TOAST_KEY='2in1flags:mockup-toast:v1';
  function setMockupToast(active){
    const el=document.getElementById('hfd-mockup-toast');
    if(!el)return;
    if(active){
      el.classList.remove('is-leaving');
      el.hidden=false;
      return;
    }
    if(window.__2in1MockupToastHold)return;
    if(el.hidden)return;
    el.classList.add('is-leaving');
    setTimeout(()=>{
      if(el.classList.contains('is-leaving')&&!window.__2in1MockupToastHold){
        el.hidden=true;
        el.classList.remove('is-leaving');
      }
    },280);
  }
  function mockupGalleryImg(page){
    const item=[...(page?.querySelectorAll('.product__media-list .product__media-item')||[])].find(node=>node.style.display!=='none');
    return item?.querySelector('img')||null;
  }
  function mockupImgPainted(img){
    const src=img?.currentSrc||img?.getAttribute('src')||'';
    return !!(img&&img.complete&&img.naturalWidth>0&&/buyer-preview|images\.printify|cloudfront\.net\/buyer-preview/i.test(src));
  }
  function showColorToast(){
    colorToast=true;
    setMockupToast(true);
  }
  function hideColorToast(){
    if(!colorToast)return;
    const page=document.querySelector('[data-product-design-page]');
    const img=mockupGalleryImg(page);
    const finish=()=>{
      colorToast=false;
      if(window.__2in1MockupToastHold)return;
      setMockupToast(false);
    };
    if(img&&!mockupImgPainted(img)){
      const done=()=>{
        img.removeEventListener('load',done);
        img.removeEventListener('error',done);
        finish();
      };
      img.addEventListener('load',done,{once:true});
      img.addEventListener('error',done,{once:true});
      setTimeout(done,8000);
      return;
    }
    finish();
  }

  function decodePayload(value){
    try{
      const normalized=String(value||'').replace(/-/g,'+').replace(/_/g,'/');
      const binary=atob(normalized+'='.repeat((4-normalized.length%4)%4));
      const bytes=Uint8Array.from(binary,char=>char.charCodeAt(0));
      return JSON.parse(new TextDecoder().decode(bytes));
    }catch(_){return null;}
  }
  function decodeDesign(value){
    const design=decodePayload(value);
    return design?.front&&design?.back?design:null;
  }
  function decodeUploads(value){
    const parsed=decodePayload(value);
    const list=Array.isArray(parsed)?parsed:Array.isArray(parsed?.uploads)?parsed.uploads:parsed?[parsed]:[];
    return list.filter(item=>item?.dataUrl&&String(item.dataUrl).startsWith('data:image/'));
  }
  function singleUploadDesign(upload){
    const item={type:'upload',value:upload.id||'upload',uploadId:upload.id||'',name:upload.name||'Custom Image',imageUrl:upload.dataUrl,previewUrl:upload.dataUrl};
    const side={count:1,cross:'single',split:'line',lineSize:16,lineColor:'#087df5',items:[item]};
    return {front:JSON.parse(JSON.stringify(side)),back:JSON.parse(JSON.stringify(side))};
  }
  function applyUploadsToDesign(design,uploads){
    if(!design||!uploads?.length)return design;
    const byId=new Map(uploads.map(item=>[String(item.id||''),item]));
    const only=uploads.length===1?uploads[0]:null;
    ['front','back'].forEach(sideName=>{
      (design[sideName]?.items||[]).forEach(item=>{
        const match=byId.get(String(item.uploadId||item.value||''))||((item.type==='upload'||item.uploadId)&&only)||null;
        if(!match?.dataUrl)return;
        item.type='upload';
        item.uploadId=match.id||item.uploadId||'';
        item.imageUrl=match.dataUrl;
        item.previewUrl=match.dataUrl;
        if(!item.name)item.name=match.name||'Custom Image';
      });
    });
    return design;
  }
  const MAX_SHARE_URL=7000;
  function encodeDesign(design){
    const safe=JSON.parse(JSON.stringify(design||{}));
    [safe.front,safe.back].forEach(side=>side?.items?.forEach(item=>delete item.imageUrl));
    const json=JSON.stringify(safe);
    const bytes=new TextEncoder().encode(json);
    let binary='';bytes.forEach(byte=>binary+=String.fromCharCode(byte));
    return btoa(binary).replace(/\+/g,'-').replace(/\//g,'_').replace(/=+$/,'');
  }
  function syncDesignUrl(design){
    if(!(design?.front||design?.back))return;
    if(!document.querySelector('[data-product-design-page]'))return;
    try{
      const encoded=encodeDesign(design);
      const url=new URL(location.href);
      if(url.searchParams.get('design')===encoded)return;
      url.searchParams.set('design',encoded);
      if(url.toString().length>MAX_SHARE_URL)return;
      const next=`${url.pathname}${url.search}${url.hash}`;
      history.replaceState(history.state,'',next);
      const shareHref=`${window.shopUrl||location.origin}${next}`;
      document.querySelectorAll('share-button').forEach(button=>{
        if(typeof button.updateUrl==='function')button.updateUrl(shareHref);
      });
    }catch(_){}
  }
  function readDraft(){
    try{return JSON.parse(localStorage.getItem(DRAFT_KEY)||'null');}catch(_){return null;}
  }
  function quantize(value,digits){
    const n=Number(value);
    if(!Number.isFinite(n))return 0;
    const f=Math.pow(10,digits==null?4:digits);
    return Math.round(n*f)/f;
  }
  function designIdentity(design){
    const slim=side=>({count:side?.count,cross:side?.cross,lineColor:side?.lineColor,lineSize:side?.lineSize,items:(side?.items||[]).map(i=>{
      const p=i.presentation;
      return {type:i.type,value:i.value,uploadId:i.uploadId,scale:quantize(i.scale||100,0),fitEntire:!!i.fitEntire,focus:i.focus==null?1:quantize(i.focus,0),p:p&&Number(p.w)>0?[quantize(p.x),quantize(p.y),quantize(p.w),quantize(p.h)]:null};
    })});
    try{return JSON.stringify({f:slim(design?.front),b:slim(design?.back)});}catch(_){return '';}
  }
  function keepUploadIds(design,existing){
    if(!design)return design;
    let meta=null;
    try{meta=JSON.parse(localStorage.getItem('2in1flags:design:upload-meta:v1')||'null');}catch(_){}
    ['front','back'].forEach(side=>{
      (design[side]?.items||[]).forEach((item,index)=>{
        const isUpload=item?.type==='upload'||item?.type==='my-uploads'||item?.uploadId;
        if(!isUpload)return;
        const have=String(item.uploadId||'').trim();
        if(have&&have!=='upload')return;
        const prev=existing?.[side]?.items?.[index];
        const id=String(prev?.uploadId||prev?.value||meta?.[side]?.[index]?.id||'').trim();
        if(!id||id==='upload'||!/^up_/i.test(id))return;
        item.uploadId=id;
        if(!item.value||item.value==='upload')item.value=id;
      });
    });
    return design;
  }
  function adoptSharedDesignFromUrl(){
    const design=decodeDesign(new URLSearchParams(location.search).get('design'));
    if(!design)return null;
    const existing=readDraft();
    const draft=keepUploadIds({version:1,updatedAt:new Date().toISOString(),...design},existing);
    const same=designIdentity(readDraft())===designIdentity(draft);
    try{localStorage.setItem(DRAFT_KEY,JSON.stringify(draft));}catch(_){}
    if(!same){
      sessionStorage.removeItem(STORE_KEY);
      window.__2in1Mockups=null;
    }
    return draft;
  }
  function importShopDesign(){
    try{
      const params=new URLSearchParams(location.search);
      const uploads=decodeUploads(params.get('upload'));
      let design=decodeDesign(params.get('design'));
      if(!design&&uploads[0])design=singleUploadDesign(uploads[0]);
      else if(design&&uploads.length)design=applyUploadsToDesign(design,uploads);
      const shopJump=params.get('shop')==='1';
      if(!design){
        const draft=readDraft();
        if(draft?.front)syncDesignUrl(draft);
        return false;
      }
      const previous=readDraft();
      const draft=keepUploadIds({version:1,updatedAt:new Date().toISOString(),...design},previous);
      const same=designIdentity(previous)===designIdentity(draft);
      localStorage.setItem(DRAFT_KEY,JSON.stringify(draft));
      if(!same){
        sessionStorage.removeItem(STORE_KEY);
        window.__2in1Mockups=null;
      }
      document.querySelectorAll('[data-design-missing]').forEach(el=>el.remove());
      if(shopJump||uploads.length){
        params.delete('shop');
        params.delete('upload');
        const next=`${location.pathname}${params.toString()?`?${params}`:''}${location.hash||''}`;
        history.replaceState(history.state,'',next);
      }
      syncDesignUrl(draft);
      if(!same)document.dispatchEvent(new CustomEvent('2in1:draft-saved'));
      return true;
    }catch(error){console.warn('Saved design shop import failed',error);return false;}
  }

  function readStore(){
    if(window.__2in1Mockups?.products)return window.__2in1Mockups;
    try{return JSON.parse(sessionStorage.getItem(STORE_KEY)||'null')||{products:{}};}
    catch(_){return {products:{}};}
  }
  function writeStore(store){
    try{sessionStorage.setItem(STORE_KEY,JSON.stringify(store));}catch(_){ }
    window.__2in1Mockups=store;
    document.dispatchEvent(new CustomEvent('2in1:mockups',{detail:store}));
  }
  function catalogKeyFromHandle(handle){
    if(window.__2in1PrintifyCatalog?.catalogKeyFromHandle)return window.__2in1PrintifyCatalog.catalogKeyFromHandle(handle)||'';
    const value=String(handle||'').toLowerCase();
    if(value.includes('hat'))return 'hat';
    if(value.includes('mug'))return 'mug';
    if(value.includes('tote'))return 'tote';
    if(value.includes('zip'))return 'ziphoodie';
    if(value.includes('youth')&&value.includes('hoodie'))return 'youthhoodie';
    if(value.includes('hoodie'))return 'hoodie';
    if(value==='infant-bodysuit')return 'bodysuit';
    if(value.includes('onesie')||value.includes('bodysuit')||value.includes('infant'))return 'onesie';
    if(value.includes('garment')||value.includes('sweatshirt')||value.includes('crewneck')||value.includes('crew'))return 'sweatshirt';
    if(value.includes('long')&&value.includes('sleeve'))return value.includes('youth')?'youthlongsleeve':'longsleeve';
    if(value.includes('t-shirt')||value.includes('tee')||/(^|-)shirt/.test(value))return 'tee';
    if(value.includes('flag'))return 'flag';
    return '';
  }
  function knownHandleForKind(kind){
    const mapped=window.__2in1PrintifyCatalog?.byKey?.[kind]?.handle;
    if(mapped)return mapped;
    const map={flag:'double-sided-custom-flag-2in1flags-logo-outdoor-banner',tee:'unisex-custom-flag-t-shirt',longsleeve:'long-sleeve-tee',youthlongsleeve:'youth-long-sleeve-tee',hoodie:'2in1flags-logo-hoodie-eco-friendly-pullover-sweatshirt',youthhoodie:'youth-hoodie',ziphoodie:'2-in-1-flags-zip-hoodie-puerto-rico-texas-flag-mashup',sweatshirt:'youth-crewneck-sweatshirt',hat:'dad-hat',mug:'custom-flag-mug',tote:'custom-flag-tote-bag',onesie:'2-in-1-flags-baby-bodysuit-cute-dual-flag-infant-onesie',bodysuit:'infant-bodysuit'};
    return map[kind]||'';
  }
  function handleFrom(node){
    const host=node.closest('[data-product-handle], .product-card-wrapper, [data-product-design-page], .cart-item, [data-hfd-product], td');
    if(host?.dataset?.productHandle)return host.dataset.productHandle;
    const mockup=host?.dataset?.mockup||host?.dataset?.catalog;
    if(mockup&&knownHandleForKind(mockup))return knownHandleForKind(mockup);
    const href=host?.querySelector?.('a[href*="/products/"]')?.getAttribute('href')||node.getAttribute?.('href')||'';
    const match=String(href).match(/\/products\/([^/?#]+)/i);
    return match?decodeURIComponent(match[1]):'';
  }
  function setImg(img,url){
    if(!img||!url)return;
    if(!img.dataset.originalSrc){
      img.dataset.originalSrc=img.getAttribute('src')||'';
      img.dataset.originalSrcset=img.getAttribute('srcset')||'';
    }
    img.removeAttribute('srcset');
    img.removeAttribute('sizes');
    img.setAttribute('src',url);
    img.setAttribute('srcset',url);
    img.style.objectFit='contain';
    img.style.objectPosition='center';
  }
  function mediaId(node){
    const raw=String(node?.dataset?.mediaId||node?.getAttribute?.('data-media-id')||'');
    const match=raw.match(/(\d+)$/);
    return match?match[1]:raw;
  }
  function clearLoading(){
    document.querySelectorAll('.is-printify-loading').forEach(node=>node.classList.remove('is-printify-loading'));
  }
  function restoreImgs(root){
    if(!root)return;
    root.classList?.remove?.('has-printify-mockup','is-printify-loading');
    root.querySelectorAll?.('[data-story-design]')?.forEach(node=>{node.hidden=false});
    const imgs=root.tagName==='IMG'?[root]:[...root.querySelectorAll('img[data-original-src]')];
    imgs.forEach(img=>{
      const src=img.dataset.originalSrc;
      if(!src)return;
      img.setAttribute('src',src);
      img.setAttribute('srcset',img.dataset.originalSrcset||src);
    });
  }
  function stripOverlay(root){
    root.querySelectorAll('[data-design-print],[data-shop-design],[data-product-design]').forEach(node=>node.remove());
  }
  function galleryUrls(urls,page){
    if(!urls?.front){
      const generated=(urls?.images||[]).filter(Boolean);
      return generated.length?[...new Set(generated)]:[];
    }
    const flagPair=!!page?.querySelector('.hfd__flag-product-gallery, .hfd__flag-media-label');
    if(flagPair){
      const second=(urls.back&&urls.back!==urls.front)?urls.back:(urls.images||[]).find(src=>src&&src!==urls.front);
      return [urls.front,second||urls.front];
    }
    const slots=page?page.querySelectorAll('.product__media-list .product__media-item').length:0;
    if(slots===2||(urls.back&&urls.back!==urls.front)){
      return [urls.front,urls.back&&urls.back!==urls.front?urls.back:urls.front];
    }
    const generated=(urls.images||[]).filter(Boolean);
    if(generated.length)return [...new Set(generated)];
    return [urls.front,urls.back].filter(Boolean);
  }
  function applyProductGallery(page,handle,gallery,urls){
    const items=[...page.querySelectorAll('.product__media-list .product__media-item')];
    const thumbs=[...page.querySelectorAll('.thumbnail-list__item')];
    const byMediaId=new Map();
    const liveGallery=[];
    const flagGallery=!!page.querySelector('.hfd__flag-product-gallery');
    items.forEach((item,i)=>{
      let url=gallery[i];
      if(flagGallery&&urls){
        const side=String(item.querySelector('.hfd__flag-media-label')?.textContent||'').trim().toLowerCase();
        if(side==='back')url=urls.back||urls.front||url;
        else if(side==='front')url=urls.front||url;
      }
      item.style.display=url?'':'none';
      if(!url)return;
      const id=mediaId(item);
      if(id)byMediaId.set(id,url);
      stripOverlay(item);
      item.querySelectorAll('img').forEach(img=>setImg(img,url));
      liveGallery.push(url);
    });
    thumbs.forEach((item,i)=>{
      const url=gallery[i];
      item.style.display=url?'':'none';
      if(!url)return;
      item.querySelectorAll('img').forEach(img=>setImg(img,url));
    });
    return {gallery:liveGallery.length?liveGallery:gallery,byMediaId};
  }
  function applyHandle(root,handle,urls){
    if(!urls?.front)return;
    stripOverlay(root);
    root.classList.add('has-printify-mockup');
    root.classList.remove('is-printify-loading');
    root.querySelectorAll('[data-story-design]').forEach(node=>{node.hidden=true;node.replaceChildren();});
    const images=[...root.querySelectorAll('.card__media img, .homepage-story__product-image img, .cart-item__image, .order-item-media img, .product-media-container img')];
    if(!images.length)return;
    images.forEach((img,i)=>setImg(img,i===1&&urls.back?urls.back:urls.front));
  }
  function mediaNodes(root){
    if(!root)return[];
    if(root.tagName==='IMG')return[root];
    return [...root.querySelectorAll('img')];
  }
  function liveGalleryMap(page){
    const byMediaId=new Map();
    const urls=[];
    [...(page?.querySelectorAll('.product__media-list .product__media-item')||[])].forEach(item=>{
      if(item.style.display==='none')return;
      const img=item.querySelector('img');
      const src=img?.currentSrc||img?.getAttribute('src')||'';
      if(!src)return;
      urls.push(src);
      const ids=[mediaId(item),mediaId(item.querySelector('[data-media-id]')),mediaId(img)].filter(Boolean);
      ids.forEach(id=>byMediaId.set(id,src));
    });
    return {urls,byMediaId};
  }
  function syncZoomImages(gallery,byMediaId){
    const page=document.querySelector('[data-product-design-page]');
    const live=liveGalleryMap(page);
    const urls=live.urls.length?live.urls:(gallery||[]);
    const ids=live.byMediaId.size?live.byMediaId:(byMediaId||new Map());
    document.querySelectorAll('.product-media-modal__content, product-modal').forEach(modal=>{
      const content=modal.classList?.contains('product-media-modal__content')?modal:modal.querySelector('.product-media-modal__content');
      if(!content)return;
      let shown=0;
      [...content.children].forEach(item=>{
        const imgs=mediaNodes(item);
        if(!imgs.length)return;
        const url=ids.get(mediaId(item))||ids.get(mediaId(imgs[0]))||urls[shown];
        shown+=1;
        item.style.display=url?'':'none';
        if(!url)return;
        stripOverlay(item);
        imgs.forEach(img=>setImg(img,url));
      });
    });
    const zoomUrl=urls[0];
    if(!zoomUrl)return;
    document.querySelectorAll('.image-magnify-full-size').forEach(overlay=>{
      overlay.style.backgroundImage=`url('${zoomUrl}')`;
      mediaNodes(overlay).forEach(img=>setImg(img,zoomUrl));
    });
  }
  function restoreProductModal(){
    document.querySelectorAll('.product-media-modal__content').forEach(modal=>{
      [...modal.children].forEach(item=>{
        item.style.display='';
        restoreImgs(item);
      });
    });
    document.querySelectorAll('.image-magnify-full-size').forEach(overlay=>overlay.remove());
  }
  function productForHandle(products,handle){
    if(!products||!handle)return null;
    if(products[handle]?.front)return products[handle];
    const catalog=window.__2in1PrintifyCatalog;
    const primary=catalog?.primaryHandle?.(handle)||handle;
    if(products[primary]?.front)return products[primary];
    const aliases=catalog?.handlesFor?.({handle,handles:[handle,primary]})||[handle,primary];
    for(const name of aliases){
      if(products[name]?.front)return products[name];
    }
    const want=String(primary||handle).toLowerCase();
    return Object.entries(products).find(([name,item])=>{
      if(!item?.front)return false;
      const key=catalog?.primaryHandle?.(name)||name;
      return String(key).toLowerCase()===want;
    })?.[1]||null;
  }
  function apply(){
    const page=document.querySelector('[data-product-design-page]');
    if(!page){
      clearLoading();
      return;
    }
    if(!document.getElementById('printify-mockup-style')){
      const style=document.createElement('style');
      style.id='printify-mockup-style';
      style.textContent=[
        '.has-printify-mockup [data-story-design],.has-printify-mockup [data-design-print]{display:none!important}',
        '.has-printify-mockup img{object-fit:contain!important;object-position:center center}',
        '.is-printify-loading img{opacity:.55;transition:opacity .18s ease}'
      ].join('');
      document.head.appendChild(style);
    }
    const store=readStore();
    const loading=!!store.loading;
    const products=store.products||{};
    if(!loading)clearLoading();
    document.querySelectorAll('[data-design-print],[data-shop-design],[data-product-design]').forEach(node=>node.remove());
    const handle=page.dataset.productHandle||'';
    const product=productForHandle(products,handle);
    const variantId=Number(page.querySelector('form[data-type="add-to-cart-form"] [name="id"], product-form [name="id"]')?.value)||0;
    const urls=urlsForSelection(product,page,variantId);
    if(urls?.front){
      if(urls.stockOnly){
        page.classList.remove('has-printify-mockup','is-printify-loading');
        page.setAttribute('data-stock-front',urls.front||'');
        page.setAttribute('data-stock-back',urls.back||urls.front||'');
      }else{
        page.classList.add('has-printify-mockup');
        page.classList.remove('is-printify-loading');
      }
      const gallery=galleryUrls(urls,page);
      const applied=applyProductGallery(page,handle,gallery,urls);
      if(urls.stockOnly){
        page.querySelectorAll('.hfd__flag-product-gallery img').forEach(img=>{
          const item=img.closest('.product__media-item');
          const side=String(item?.querySelector('.hfd__flag-media-label')?.textContent||'').trim().toLowerCase();
          const stock=side==='back'?(urls.back||urls.front):urls.front;
          if(stock){
            img.dataset.originalSrc=stock;
            img.dataset.originalSrcset=stock;
          }
        });
      }
      syncZoomImages(applied.gallery,applied.byMediaId);
    }else{
      const flagPage=!!page.querySelector('.hfd__flag-product-gallery, .hfd__flag-media-label')||page.dataset?.catalog==='flag';
      if(flagPage){
        const stock=flagStockUrls(page);
        if(stock?.front){
          page.classList.remove('has-printify-mockup','is-printify-loading');
          const gallery=galleryUrls(stock,page);
          applyProductGallery(page,handle,gallery,stock);
          page.querySelectorAll('.hfd__flag-product-gallery img').forEach(img=>{
            const item=img.closest('.product__media-item');
            const side=String(item?.querySelector('.hfd__flag-media-label')?.textContent||'').trim().toLowerCase();
            const url=side==='back'?(stock.back||stock.front):stock.front;
            if(url){
              img.dataset.originalSrc=url;
              img.dataset.originalSrcset=url;
            }
          });
          return;
        }
        page.classList.remove('is-printify-loading');
        return;
      }
      page.classList.remove('has-printify-mockup');
      page.querySelectorAll('.product__media-list .product__media-item, .thumbnail-list__item').forEach(item=>{
        item.style.display='';
        restoreImgs(item);
      });
      restoreProductModal();
      if(loading)page.classList.add('is-printify-loading');
      else page.classList.remove('is-printify-loading');
    }
  }

  const norm=v=>String(v||'').toLowerCase().replace(/×/g,'x').replace(/[^a-z0-9]+/g,' ').trim();
  function selectedColorKey(page){
    const groups=[...page.querySelectorAll('fieldset.product-form__input, .product-form__input')];
    const colorGroup=groups.find(group=>/color/i.test(group.querySelector('legend')?.textContent||group.getAttribute('name')||''));
    const radio=colorGroup?.querySelector('input:checked')?.value;
    if(radio)return norm(radio);
    const select=[...page.querySelectorAll('select[name^="options["]')].find(node=>/color/i.test(node.getAttribute('name')||''));
    if(select?.value)return norm(select.value);
    return '';
  }
  function selectedSizeKey(page){
    const groups=[...page.querySelectorAll('fieldset.product-form__input, .product-form__input')];
    const sizeGroup=groups.find(group=>/size/i.test(group.querySelector('legend')?.textContent||group.getAttribute('name')||''));
    const radio=sizeGroup?.querySelector('input:checked')?.value;
    const active=page.querySelector('[data-size].is-active')?.dataset.size;
    const select=[...page.querySelectorAll('select[name^="options["]')].find(node=>/size/i.test(node.getAttribute('name')||''));
    const raw=radio||active||select?.value||'';
    const t=norm(raw);
    const dim=t.match(/(\d+)\s*x\s*(\d+)/);
    return dim?`${dim[1]}x${dim[2]}`:t;
  }
  function urlsForSelection(product,page,variantId){
    if(product?.designArtOnly)return null;
    const color=selectedColorKey(page);
    const size=selectedSizeKey(page);
    const flagPage=!!page?.querySelector('.hfd__flag-product-gallery, .hfd__flag-media-label')||page?.dataset?.catalog==='flag';
    if(product?.front){
      if(variantId&&product.variants?.[variantId]?.front&&!product.variants[variantId].designArtOnly)return product.variants[variantId];
      if(color&&product.colors?.[color]?.front&&!product.colors[color].designArtOnly)return product.colors[color];
      if(size){
        const sizeHit=product.colors?.[size]||product.colors?.[size.replace(/x/g,' x ')]||product.colors?.[norm(size)];
        if(sizeHit?.front&&!sizeHit.designArtOnly)return sizeHit;
      }
      if(color&&product.color&&color===norm(product.color)&&product.front)return product;
      if(size&&product.color&&(size===norm(product.color)||size===String(product.color).replace(/\s+/g,''))&&product.front)return product;
      // Flag sizes: do not reuse another size's applied mockup.
      if(flagPage)return flagStockUrls(page);
      // Merch: specific size/color chosen but not cached yet — do not reuse another size's mockup.
      if(size||color)return null;
      return product;
    }
    if(flagPage)return flagStockUrls(page);
    return null;
  }
  function flagStockUrls(page){
    if(!page)return null;
    const btn=page.querySelector('[data-size].is-active')||page.querySelector('[data-size][data-front-url]');
    const front=btn?.dataset?.frontUrl||page.getAttribute('data-stock-front')||'';
    const back=btn?.dataset?.backUrl||page.getAttribute('data-stock-back')||front;
    if(!front)return null;
    return {front,back:back||front,stockOnly:true};
  }
  function selectedVariantTitle(page){
    const groups=[...page.querySelectorAll('fieldset.product-form__input')];
    const values=groups.map(group=>{
      const checked=group.querySelector('input:checked');
      if(checked?.value)return checked.value;
      return group.querySelector('select')?.value||'';
    }).filter(Boolean);
    if(values.length)return values.join(' / ');
    const select=[...page.querySelectorAll('select[name^="options["]')].map(node=>node.value).filter(Boolean);
    if(select.length)return select.join(' / ');
    return page.querySelector('[data-size].is-active')?.dataset.size||'';
  }
  function cachedUrlsForPage(page){
    const handle=page?.dataset?.productHandle||'';
    const store=readStore();
    if(!store.frontUrl)return null;
    const current=productForHandle(store.products,handle)||{};
    const color=selectedColorKey(page);
    const size=selectedSizeKey(page);
    const shopifyVariantId=Number(page.querySelector('form[data-type="add-to-cart-form"] [name="id"], product-form [name="id"]')?.value)||0;
    if(shopifyVariantId&&current.variants?.[shopifyVariantId]?.front)return current.variants[shopifyVariantId];
    if(color&&current.colors?.[color]?.front)return current.colors[color];
    if(size){
      const sizeHit=current.colors?.[size]||current.colors?.[size.replace(/x/g,' x ')]||current.colors?.[norm(size)];
      if(sizeHit?.front)return sizeHit;
    }
    if(color&&current.color===color&&current.front)return current;
    if(size&&current.color&&(size===norm(current.color)||size===String(current.color).replace(/\s+/g,''))&&current.front)return current;
    if(size||color)return null;
    return current.front?current:null;
  }
  function stampCachedVariant(page,cached){
    const handle=page?.dataset?.productHandle||'';
    const shopifyVariantId=Number(page.querySelector('form[data-type="add-to-cart-form"] [name="id"], product-form [name="id"]')?.value)||0;
    const color=selectedColorKey(page);
    const size=selectedSizeKey(page);
    if(!handle||!cached?.front)return;
    const store=readStore();
    const previous=productForHandle(store.products,handle)||store.products?.[handle]||{};
    if(shopifyVariantId&&previous.variants?.[shopifyVariantId]?.front===cached.front)return;
    store.products=store.products||{};
    const key=handle;
    store.products[key]={
      ...previous,
      variants:{...(previous.variants||{}),...(shopifyVariantId?{[shopifyVariantId]:cached}:{})},
      colors:{...(previous.colors||{}),...(color?{[color]:cached}:{}),...(size?{[size]:cached}:{})},
      selectedVariantId:shopifyVariantId||previous.selectedVariantId,
      color:color||size||previous.color
    };
    writeStore(store);
  }
  function requestMissingColor(page){
    const handle=page?.dataset?.productHandle||'';
    const store=readStore();
    if(!handle||!store.frontUrl||store.loading)return;
    if(cachedUrlsForPage(page)?.front)return;
    document.dispatchEvent(new CustomEvent('2in1:need-color',{detail:{
      handle,
      color:selectedColorKey(page)||selectedSizeKey(page),
      title:selectedVariantTitle(page),
      printifyId:(window.__2in1PrintifyCatalog?.ids||{})[handle]||''
    }}));
  }
  function isWhiteTitle(title){
    const t=String(title||'').toLowerCase();
    return t.includes('white')&&!t.includes('off white');
  }
  function selectDefaultWhite(page){
    if(!page||new URLSearchParams(location.search).has('variant'))return;
    const white=[...page.querySelectorAll('fieldset.product-form__input input[type="radio"]')].find(input=>isWhiteTitle(input.value));
    if(white&&!white.checked)white.click();
    page.querySelectorAll('select[name^="options["]').forEach(select=>{
      const option=[...select.options].find(item=>isWhiteTitle(item.value)||isWhiteTitle(item.textContent));
      if(option&&select.value!==option.value){
        select.value=option.value;
        select.dispatchEvent(new Event('change',{bubbles:true}));
      }
    });
  }
  function queueVariantSync(page){
    if(!page)return;
    apply();
    const cached=cachedUrlsForPage(page);
    // Never show the "Please wait while we apply your design…" toast on load/refresh/size change.
    hideColorToast();
    if(cached?.front){
      stampCachedVariant(page,cached);
      return;
    }
    clearTimeout(queueVariantSync._t);
    queueVariantSync._t=setTimeout(()=>requestMissingColor(page),80);
  }

  function init(){
    importShopDesign();
    const page=document.querySelector('[data-product-design-page]');
    if(!page)return;
    setMockupToast(false);
    hideColorToast();
    apply();
    document.addEventListener('2in1:mockups',()=>{
      apply();
      const page=document.querySelector('[data-product-design-page]');
      if(page)queueVariantSync(page);
    });
    document.addEventListener('2in1:mockups-loading',apply);
    document.addEventListener('2in1:mockups-error',()=>{
      clearLoading();
      apply();
    });
    document.addEventListener('cart:refresh',apply);
    document.addEventListener('cart:updated',apply);
    document.addEventListener('shopify:section:load',apply);
    selectDefaultWhite(page);
    page.addEventListener('change',e=>{
      if(e.target.matches('input,select'))queueVariantSync(page);
    },true);
    page.addEventListener('input',e=>{
      if(e.target.matches('input[type="radio"],select'))queueVariantSync(page);
    },true);
    document.addEventListener('variant:change',()=>{
      queueVariantSync(page);
      setTimeout(()=>syncDesignUrl(readDraft()),0);
    });
    const handle=page.dataset.productHandle||'';
    if(readStore().products?.[handle]?.front)queueVariantSync(page);
    const bindZoom=()=>{
      document.querySelectorAll('product-modal').forEach(modal=>{
        if(modal.dataset.mockupBound)return;
        modal.dataset.mockupBound='1';
        new MutationObserver(()=>{if(modal.hasAttribute('open'))apply();}).observe(modal,{attributes:true,attributeFilter:['open']});
      });
    };
    bindZoom();
    document.addEventListener('2in1:product-zoom-open',apply);
    document.addEventListener('click',event=>{
      if(!event.target.closest('modal-opener.product__modal-opener, .product__media-toggle, product-modal, .image-magnify-hover, .image-magnify-full-size'))return;
      apply();
      requestAnimationFrame(apply);
    },true);
    new MutationObserver(()=>{clearTimeout(init._t);init._t=setTimeout(apply,80);}).observe(page,{childList:true,subtree:true});
  }
  adoptSharedDesignFromUrl();
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',init,{once:true});
  else init();
})();